export default __webpack_public_path__ + "static/media/logoD.30a91c2c.png";